import React, { ReactElement } from 'react';
import moment from 'moment-timezone';
import LiveClock from './LiveClock';
import './FarmLocalTimezone.scss';
import { useAppSelector } from '../../reducers/rootReducer';
import { entityInfoSelectors } from '../../reducers/entityInfoSlice';

function checkForCorrectZoneFormat(timezone: string): moment.MomentZone | null {
  return moment.tz.zone(timezone);
}

function FarmLocalTimezone({ farmDetails }): ReactElement {
  /** Get the farm id from the URL / react-router-dom */
  const entityInfo = useAppSelector(entityInfoSelectors.selectEntityInfo);

  const entityZone = checkForCorrectZoneFormat(
    farmDetails?.farmTimeZone || entityInfo?.farmTimeZone,
  );
  let farmClock: ReactElement;
  if (entityZone != null) {
    farmClock = (
      <div className="farm-clock">
        <span>Farm Local Time:</span>
        <LiveClock
          format="HH:mm"
          ticking
          timezone={farmDetails?.farmTimeZone || entityInfo?.farmTimeZone}
        />
      </div>
    );
  } else {
    farmClock = (
      <div className="farm-clock">
        <span>Time in UTC:</span>
        <LiveClock format="HH:mm" ticking timezone="UTC" />
      </div>
    );
  }
  return farmClock;
}
export default FarmLocalTimezone;
